import PanelTabs from './PanelTabs';

export default PanelTabs;
